module.exports = __webpack_public_path__ + "img/sri-lanka.1937c329.png";